// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  organizationId: __t.string().name("organization_id"),
  userId: __t.string().name("user_id"),
  product: __t.string(),
  apiKey: __t.string().name("api_key"),
  isPowerOnProPlus: __t.option(__t.bool()).name("is_power_on_pro_plus"),
  createdAt: __t.option(__t.timestamp()).name("created_at"),
});
